import type { MessageDemande } from '../../types';
import { MessageSlack } from './MessageSlack';
import { MessagesEmails } from './MessagesEmails';
import { MessagesSms } from './MessagesSms';
import { titreSlack } from './format';

/** Tous les messages d'une demande (ceux que la personne a le droit de voir) : Slack, e-mails aux extérieur·e·s, SMS d'annulation. */
export function MessagesDemande({ demandeId, messages, titreSeance, onChange }: {
  demandeId: number; messages: MessageDemande[]; titreSeance: string; onChange: () => void;
}) {
  const slack = messages.filter((m) => m.canal === 'slack');
  const emails = messages.filter((m) => m.canal === 'email');
  const sms = messages.filter((m) => m.canal === 'sms');
  if (messages.length === 0) return <div className="empty-state">Aucun message pour cette demande.</div>;
  return (
    <div className="msg-pile">
      {slack.map((m, i) => <MessageSlack key={m.id} message={m} titre={titreSlack(i)} onChange={onChange} />)}
      <MessagesEmails messages={emails} onChange={onChange} />
      <MessagesSms demandeId={demandeId} messages={sms} titre={`Annulation de ${titreSeance}, aujourd'hui`} onChange={onChange} />
    </div>
  );
}
